import { CmsApiScrollTrackingBlockData } from 'modules/cms/api/types/CmsApiScrollTracking';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsScrollTrackingBlock } from './CmsScrollTrackingBlock';

export const CmsScrollTrackingBlockMapping: CmsBlockMapping<CmsApiScrollTrackingBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.FULL,
    Component: CmsScrollTrackingBlock,

    AmpComponent: CmsScrollTrackingBlock,
  };
